import { download, generateCsv, mkConfig } from "export-to-csv"
import { MRT_Row } from "material-react-table"
import { toCurrency, toDinero } from "../../../../../currency/currencyLib"
import { useMoney } from "../../../../../currency/useMoney"
import { OrdersPOSType } from "../pages/posTypes"

export function useExportPOSOrdersToCsv(startDate: string, endDate: string) {
    const moneyFactory = useMoney({ locale: "da-DK" })

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ".",
        useBom: true,
        useKeysAsHeaders: true,
        filename: `Facilitynet-orders-POS-${startDate}_${endDate}`,
    })

    const handleExportRows = (rows?: MRT_Row<OrdersPOSType>[]) => {
        if (!rows) return

        const rowData = rows.map((row) => row.original)

        const exportRows = rowData.map((order) => {
            return {
                "Transaction id": order.id ?? "",
                ["Amount" + ` (${moneyFactory.getLocalizedCurrencySymbol(toCurrency(order.amount.currency))})`]:
                    moneyFactory.formatAsNumber(toDinero(order.amount)),
                "Transaction Time": order.created,
                "User id": order?.customer?.id ?? "",
                "User name": order?.customer?.displayName,
                "E-mail": order?.customer?.email,
                "Order status": order?.orderStatus,
                "Order type": order?.orderType,
            }
        })

        const csv = generateCsv(csvOptions)(exportRows)
        download(csvOptions)(csv)
    }

    return { handleExportRows }
}
